<!-- <div style="display: block;">
    <h2>Peso Carregado (Weight Loaded)</h2>
    <canvas baseChart
            [datasets]="[{ data: chartData, label: 'Peso Carregado' }]"
            [labels]="chartLabels"
            chartType="bar">
    </canvas>
  </div> -->


<div>
    <div class="botoesTitulo">
        <div class="sub-header left">
            <!-- Input fields to select the date range -->
            <input #dateInput type="date" [(ngModel)]="startDate" class="select-input">
            <input #dateInput2 type="date" [(ngModel)]="endDate" class="select-input">
            <!-- Button to trigger the filter -->
            <button (click)="applyDateFilter()" class="select-input">Aplicar Filtro</button>
            <button class="select-input" (click)="clearFilter()">Limpar filtro</button>
            <!-- <input type="text" name="searchText" [(ngModel)]="searchText" (input)="filterItems()"
            placeholder="Find" class="ultimo-input">
        <div *ngIf="filteredItems" class="sub-header">
            <span style=" display: flex; align-items: center; margin: 0;">Total Rotas: {{
                filteredItems.length }} </span>
        </div> -->
            <!-- <div class="sub-header right">
            <div class="icone-setting">
                <!-- <i-feather name="printer"></i-feather> --
                <button class="btn-frete icone-setting" mat-button
                    (click)="exportExcel()"><i-feather name="printer"></i-feather>Print</button>
            </div>
        </div> -->
        </div>
        <div class="titulo">
            <h2>Ocupação dos veículos Interplantas</h2>
        </div>
    </div>
    <div class="medias">
        <div class="grafico">
            <canvas #geral></canvas>
        </div>
    </div>
</div>
<div>
    <div class="tituloMedias">
        <h2>Médias das ocupações dos veículos Interplantas</h2>
    </div>
    <div class="medias">
        <div class="graficoMedia">
            <canvas #placas></canvas>
        </div>
        <!-- </div> -->
        <!-- </div> -->
        <!-- <div class="conteudo">
    <div class="titulo">
        <h2>Ocupação dos veículos Interplantas</h2>
    </div> -->
        <!-- <div class="grafico"> -->
        <div class="graficoMedia">
            <canvas #datas></canvas>
        </div>
    </div>
</div>

<!-- <div class="chart-container" id="chartQuantidade">
    <highcharts-chart [Highcharts]="Highcharts" [options]="barQuantidadeContainers"
      style="height: 400px; width: 100%;"></highcharts-chart>
  </div> -->

<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>